import { FC } from "react";

import { Pagination } from "antd";

import { useAppDispatch, useAppSelector } from "store";
import { getContractsSelector } from "store/contracts/contracts.selector";
import { updateContractsPagination } from "store/contracts/contracts.actions";
import { getContracts } from "store/contracts/contracts.thunks";

const ContractsFooter: FC = () => {
  const dispatch = useAppDispatch();
  const { pagination } = useAppSelector(getContractsSelector);

  const handleUpdatePagination = (page: number, pageSize: number) => {
    dispatch(updateContractsPagination(page, pageSize));
    dispatch(getContracts());
  }

  return (
    <div className="default-footer-wrapper">
      <Pagination
        total={ pagination.count }
        showTotal={ (total, range) => `${ range[ 0 ] }-${ range[ 1 ] } of ${ total } items` }
        pageSize={ pagination.rowsPerPage }
        current={ pagination.page }
        onChange={ handleUpdatePagination }
      />
    </div>
  )
}

export default ContractsFooter;
